import styled from '@emotion/styled';

export const Body3Bold = styled.p`
  font-family: Khula-Bold;
  color: ${(props) => props.color};
  font-size: 16px;
  line-height: 25px;
`;
